import { render, staticRenderFns } from "./originalDetail.vue?vue&type=template&id=250dfbb2"
import script from "./originalDetail.vue?vue&type=script&lang=js"
export * from "./originalDetail.vue?vue&type=script&lang=js"
import style0 from "./originalDetail.vue?vue&type=style&index=0&id=250dfbb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports